<form nz-form class="form" nzLayout="horizontal" [formGroup]="userForm">
  <div class="drawer-form-wrapper">
    <nz-form-item>
      <nz-form-label nzFor="roleIds" nzRequired>User Role</nz-form-label>
      <nz-form-control nzErrorTip="Please select your user roles.">
        <nz-select
          nzSuffixIcon
          nzShowSearch
          nzAllowClear
          nzMode="multiple"
          nzShowArrow="true"
          nzPlaceHolder="Select a roles"
          formControlName="roleIds"
          [nzNotFoundContent]="loadingContent.loadingTemplate"
          name="roleIds">
          @for (role of roleList | async; track role) {
            <nz-option [nzLabel]="role.name" [nzValue]="role.id"></nz-option>
          }
        </nz-select>
        <app-loading-content
          #loadingContent
          [isLoading$]="isLoading"
          noDataText="No roles found">
        </app-loading-content>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-upload
        [nzFileList]="fileList"
        [nzBeforeUpload]="beforeUpload"
        [nzShowUploadList]="true"
        [nzIconRender]="iconTemplate"
        nzListType="picture"
        [nzMultiple]="false"
        [nzAccept]="'.csv'"
        nzDrop
        class="file-upload">
        <button nz-button type="button">
          <div class="upload-icon">
            <svg-icon
              [title]="'Upload File'"
              src="/assets/icon/icon-upload.svg"
              class="icon s-12"
              aria-label="Upload">
            </svg-icon>
          </div>
          <div class="wrapper">
            <p class="text s-14 fw-600 green">
              Click to upload
              <span class="text s-14 fw-400">or drag and drop</span>
            </p>
            <p class="text s-12 fw-400">CSV files only</p>
          </div>
        </button>
        <app-upload-progress
          [progress$]="uploadProgress$"></app-upload-progress>
      </nz-upload>
    </nz-form-item>
    <div class="btn-wrapper-end">
      <a
        href="/assets/samplefiles/SampleAddUsers.csv"
        download="SampleAddUsers.csv"
        nz-button
        nzType="text"
        class="primary-text-btn">
        Sample Import File
      </a>
    </div>
    <div class="display-flex justify-content-between drawer-footer">
      <button nz-button nzType="default" (click)="closeImportDrawer()">
        Cancel
      </button>
      <button
        type="button"
        (click)="submitForm()"
        nz-button
        [disabled]="fileList.length === 0"
        [nzLoading]="loading$ | async"
        nzType="primary">
        Import Users
      </button>
    </div>
  </div>
</form>

<ng-template #iconTemplate let-file>
  <svg-icon
    [title]="'CSV File'"
    src="/assets/icon/icon-csv.svg"
    class="icon s-12"
    aria-label="Csv"></svg-icon>
</ng-template>
